module.exports = __webpack_public_path__ + "media/jungle_1_TA.b77834e5.mp4";